<template>
  <section id="bi">
      <main style="text-align:left;white-space:normal">
          <div class="title">
            {{$ml.get('metrics')}}
          </div>
          <div id="filters">
            <div>
                <div class="field">
                    <label>{{$ml.get("provider")}}</label>
                    <span class="custom-dropdown"><select v-model="id" @change="resetTable()">
                        <option v-for="(p, index) in providers" :key="index" :value="p.id_provider">
                            {{p.description}}
                        </option>
                    </select></span>
                </div>

                <div class="field">
                <label>{{$ml.get("metric")}}</label>
                <span class="custom-dropdown"><select v-model="metric" @change="softReset()">
                    <option value="messages">
                        {{$ml.get('messages')}}
                    </option>
                    <option value="unsend">
                        {{$ml.get('unsent_messages')}}
                    </option>
                    <option value="subscriptions">
                        {{$ml.get('total_subscriptions')}}
                    </option>
                    <option value="status">
                        {{$ml.get('AWB_status')}}
                    </option>
                    <option value="empty">
                        {{$ml.get('empty_AWB')}}
                    </option>
                </select></span>
                </div>

                <div class="field" v-if="metric=='unsend'">
                    <label>{{$ml.get("type")}}</label>
                    <span class="custom-dropdown"><select v-model="params.type" @change="resetTable()">
                        <option value="TDM">
                            TDM
                        </option>
                        <option value="TEM">
                            TEM
                        </option>
                    </select></span>
                </div>

                <div class="field">
                <label>
                    {{$ml.get('from')}}
                </label>
                <input type="date" v-model="params.start"/>
                </div>
                <div class="field">
                <label>
                    {{$ml.get('to')}}
                </label>
                <input type="date" v-model="params.end"/>
                </div>
            </div>
            <button class="btn-blue" @click="generate()">{{$ml.get('ok')}}</button>
            <button class="btn-black" @click="reset()">{{$ml.get('reset')}}</button>

              <load-screen :notFullScreen="true" v-show="loadingTable"></load-screen>
              <table align="center" class="custom-table" v-show="!loadingTable" v-if="_results.show_value">
                <thead>
                  <th v-if="_results.show_data">{{$ml.get('with_info')}}</th>
                  <th v-if="_results.show_no_data">{{$ml.get('without_info')}}</th>
                  <th>{{$ml.get('total')}}</th>
                </thead>
                <tbody>
                  <tr>
                    <td v-if="_results.show_data" @click="detailData=_results.data">{{_results.show_data}}</td>
                    <td v-if="_results.show_no_data" @click="detailData=_results.no_data">{{_results.show_no_data}}</td>
                    <td>{{_results.show_value}}</td>
                  </tr>
                </tbody>

              </table>
              <table align="center" class="custom-table" v-if="detailData.length > 0">
                <thead>
                  <th>Link</th>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in detailData" :key="index">
                    <td><a :href="adminUrl + item.id + '/change/'">{{item.awb}}</a></td>
                  </tr>
                </tbody>
              </table>
            </div>
      </main>
    </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import LoadScreen from '@/components/LoadScreen'
export default {
  name: 'bi',
  components: {LoadScreen},
  props: {
  },
  created () {
    this.$emit('loading')
  },
  beforeMount: function () {
    Object.keys(this.$route['query']).forEach(key => {
      if (['end', 'start', 'type'].includes(key)) {
        if (Array.isArray(this.params[key]) && typeof this.$route['query'][key] === 'string') {
          this.params[key] = [this.$route['query'][key]]
        } else {
          this.params[key] = this.$route['query'][key]
        }
      } else {
        this[key] = this.$route['query'][key]
      }
    })
  },
  mounted () {
    const promises = [
      this.getProviders().then(response => { this.providers = response })
    ]
    this.$emit('loaded')
    Promise.all(promises).then(data => { this.$emit('loaded') })
  },
  data () {
    return {
      metric: '',
      params: {},
      id: '',
      providers: [],
      results: {},
      loadingTable: false,
      detailData: [],
      page: 1
    }
  },
  computed: {
    ...mapState({
    }),
    _results () {
      var output = JSON.parse(JSON.stringify(this.results))
      for (var key in output) {
        output['show_' + key] = (output[key] instanceof Array) ? output[key].length : output[key]
      }
      if (output.data) {
        output.show_data += ' - ' + (output.data.length * 100 / (output.data.length + output.no_data.length)) + '%'
        output.show_no_data += ' - ' + (output.no_data.length * 100 / (output.data.length + output.no_data.length)) + '%'
        output.show_value = (output.data.length + output.no_data.length)
      }
      return output
    },
    adminUrl () {
      console.log(process.env.API_URL)
      return (process.env.API_URL) + 'admin/freight_core/message/'
    }
  },
  methods: {
    ...mapActions({
      getProviders: 'providers/list',
      getMetric: 'metrics/metric'
    }),
    generate () {
      this.loadingTable = true
      var config = Object.assign({}, this.params, {page: this.page, id: this.id, metric: this.metric})
      this.setURLQueryParams(config)
      this.getMetric({params: this.params, id: this.id, url: this.metric}).then(response => {
        this.loadingTable = false
        this.results = response
      }).catch(e => {
        this.loadingTable = false
      })
    },
    setURLQueryParams (config) {
      Object.keys(config).forEach(key => {
        if (!config[key]) { delete config[key] }
      })
      this.$router.replace({ name: this.$route.name, query: config })
    },
    softReset () {
      this.params.type = undefined
      this.resetTable()
    },
    reset () {
      this.params = {}
      this.resetTable()
    },
    resetTable () {
      this.results = {}
      this.detailData = []
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/variables.scss";
.custom-dropdown select {
  min-width: 100%;
}
.field{
    margin: 0 1em 0 0;
}
#bi{
  display: table;
}
#filters{
  vertical-align: top;
  display: inline-block;
  padding: 1em;
  input{
    width: 100%;
    box-sizing: border-box;
  }
}
.no-width{
  display: inline-block;
}

.btn-blue{
  box-sizing: border-box;
  text-align: center;
}
.btn-100{
  margin: 1%;
  width: 98%;
}
td {
  cursor: pointer;
}

.types {
  label {
    display: inline-block;
    width: 50%;
    background: white;
    border: 1px solid lightgrey;
    box-sizing: border-box;
    text-align: center;
    transition: .2s;
    fill: $k-black;
    &:hover {
      // background: gainsboro;
      box-shadow: inset 0px 0px 5px 3px rgba($color: #000, $alpha: .1);
    }
  }
  :nth-child(2) {
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }
  :nth-child(4) {
    border-bottom-right-radius: 7px;
    border-top-right-radius: 7px;
  }
}
.selected {
  background: $k-black!important;
  fill: white!important;
  border-color: $k-black!important;
}
.custom-table{
  margin-top: 20px
}
</style>



// WEBPACK FOOTER //
// src/pages/PageBi.vue